import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from './game/config';
import { PLAYER_TUNING } from './game/player/tuning';
import { BootScene } from './game/scenes/BootScene';
import { GalleryScene } from './game/scenes/GalleryScene';
import { RoomScene } from './game/scenes/RoomScene';
import { EndlessScene } from './game/endless/EndlessScene';
import { publishSnapshot, recordError } from './game/debug/snapshot';

publishSnapshot();
window.addEventListener('error', (e) => recordError(e.message));
window.addEventListener('unhandledrejection', (e) => recordError(String(e.reason)));

declare global {
  interface Window {
    /** The running game, for the Playwright proof path and devtools. */
    __georgiGame?: Phaser.Game;
  }
}

window.__georgiGame = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  width: GAME_WIDTH,
  height: GAME_HEIGHT,
  backgroundColor: '#f6f6f2',
  scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_BOTH },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
    // N1 pages are power-of-two, so mipmaps work when the sprite is drawn below 1:1.
    mipmapFilter: 'LINEAR_MIPMAP_LINEAR',
  },
  // Cap the frame delta at 50 ms (fps.min 20): physics and controller timers never see a giant
  // step after a stall, while normal frames pass through untouched.
  fps: { target: 60, min: 20, smoothStep: true },
  physics: {
    default: 'arcade',
    // Gravity comes from the one tuning file; the room re-applies it on create.
    // Variable step: the body advances by the real frame delta, so motion is smooth on any
    // refresh rate. A fixed 60 Hz step batched 0/1/2 steps per render frame against the smoothly
    // lerped camera, which read as a ±7 px shake at run speed (measured with a per-frame probe).
    arcade: { gravity: { x: 0, y: PLAYER_TUNING.gravity }, fixedStep: false, debug: false },
  },
  scene: [BootScene, EndlessScene, RoomScene, GalleryScene],
});
